<template>
  <div v-if="!hideAllContent" class="wy-auto-qa-ai-evaluation-summary-main-page">
    <div v-if="hasSummaryData && hasAutoQAPermission" class="wy-auto-qa-ai-evaluation-summary-page">
      <div class="main-container" :class="{ 'topic-only': (!evaluationData||evaluationData.evaluationScore == null)
        &&!hasSmartTagsPermission,
        'topic-ai-tags': (!evaluationData||evaluationData.evaluationScore == null)
        && hasSmartTagsPermission}">
        <div v-if="evaluationData && evaluationData.evaluationScore != null"  class="col-1">
          <span class="large-title">Auto Evaluation Score</span>
          <div v-if="evaluationData && evaluationData.evaluationScore != null" class="score-wrapper">
            <span :class="{'fw-bold': evaluationData.evaluationScore != '-1', 'fw-bold': evaluationData.evaluationScore == '-1'}">
              {{ evaluationData.evaluationScore == '-1' ? 'N/A' : Number(evaluationData.evaluationScore).toFixed(2) }}
            </span>
          </div>
          <div v-else class="score-wrapper">
            <span class="fw-100">-</span>
          </div>
          <div class="target-wrapper">
            <span v-if="evaluationData.formTargetEnabled" class="target-value">{{ evaluationData.formTarget }}</span>
            <!-- <span v-else class="target-value"> - </span> -->
          </div>
          <div v-if="evaluationData.formTargetMessage" class="message-wrapper">
            {{evaluationData.formTargetMessage}}
          </div>
        </div>
        <div class="col-2" :class="{ 'no-ai-tags': !hasSmartTagsPermission}">
          <div class="col-inner-1">
            <div v-if="hasTrendingTopicPermission && topicData && (topicData.topic || topicData.subTopic)" class="topic-section">
              <span  v-if="topicData && topicData.topic" class="flex justify-between">
                <div class="aiColor">Topic</div>
                <div class="topic-margin pr-10">{{ topicData.topic }}</div>
              </span>
              <!-- <span v-if="topicData && topicData.subTopic" class="flex justify-between">
                <div class="aiColor no-wrap">Sub-topic</div> 
                <div class="topic-margin pr-10">{{ topicData.subTopic }}</div>
              </span>   -->
            </div>
            <div v-else-if="hasTrendingTopicPermission&&topicData" class="topic-section">
              <!-- BE returns {} -->
              <span class="flex justify-between">
                <div class="aiColor">Topic</div> 
                <div class="topic-margin fw-500">--</div>
              </span>
              <!-- <span class="flex justify-between">
                <div class="aiColor">Sub-topic</div> 
                <div class="topic-margin fw-500">--</div>
              </span> -->
            </div>
            <div v-if="evaluationData && evaluationData.evaluationScore != null" class="evaluation-sections">
              <div class="title">Evaluation Sections</div>
              <div class="sections-wrapper">
                <span v-for="(section, sectionIndex) in sectionMap" :key="sectionIndex">
                  <span class="section-row">
                    <el-tooltip popper-class="section-title-popper" placement="bottom" :content="section.name">
                      <span class="section-title">{{ section.name }}</span>
                    </el-tooltip>
                    <span v-if="section.status === 'No Data'" class="section-score">-</span>
                    <span v-else-if="section.score == '-1' && section.status == 'NA'" class="section-score">N/A</span>
                    <span v-else class="section-score">{{ Number(section.score).toFixed(2) }}</span>
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div v-if="hasSmartTagsPermission" class="col-inner-2 responsive-col">
            <div class="ai-tags-header">
              <div class="title">AI Tags</div>
              <div v-if="smartTags&&smartTags.length>0" class="dropdown-speakers">  
                <div class="filter-section speakers">
                  <el-dropdown-item>
                    <el-select
                      v-model="speaker"
                      collapse-tags
                      :popper-append-to-body="true"
                      popper-class="ai-evaluation-summary-page speakers-dropdown"
                      :class="{'both-speakers': speaker === 'both', 'all-speakers': speaker === 'all', 'agent-speakers': speaker === 'agent'}" 
                    >
                      <el-option v-for="(speaker) in speakers" :key="speaker.key" :label="speaker.label" :value="speaker.key" :data-testid="`autoQM-dataInsights-AiConversationOverview-smartTag-` + speaker.label"> </el-option>
                    </el-select>
                  </el-dropdown-item>
                </div> 
              </div>
            </div>
            
            <div v-if="smartTagList.length>0"  class="sections-wrapper">
              <div class="div-tag" v-for="smartTag in smartTagList" :key="smartTag.label">
                <el-tooltip popper-class="section-title-popper" placement="bottom">
                  <div slot="content">
                    <div class="sections-smarttag-tooltip">
                      Categories: {{ smartTag.categories.join(', ') }}
                    </div>
                    <div class="sections-smarttag-tooltip">
                      Speaker: {{ smartTag.speakers.join(', ') }}
                    </div>
                  </div>
                  <el-tag :disable-transitions="true">{{smartTag.label}}</el-tag>
                </el-tooltip>
              </div>
            </div>
            <div v-else class="sections-wrapper no-tags">
              --
            </div>
          </div>
        </div>
      </div>
      <div v-if="hasTrendingTopicPermission && topicData && (topicData.topic || topicData.subTopic)" class="row-topic-section">
        <div v-if="topicData && topicData.topic" class="flex justify-between">
          <div class="aiColor">Topic</div>
          <div class="topic-margin pr-10">{{ topicData.topic }}</div>
        </div>
      </div>
      <div v-else-if="hasTrendingTopicPermission&&topicData" class="row-topic-section">
        <!-- BE returns {} -->
        <span class="flex justify-between">
          <div class="aiColor">Topic</div> 
          <div class="topic-margin fw-500">--</div>
        </span>
      </div>
      <div v-if="hasSmartTagsPermission" class="row-ai-tags">
        <div class="ai-tags-header">
          <div class="title">AI Tags</div>
          <div v-if="smartTags&&smartTags.length>0" class="dropdown-speakers">  
            <div class="filter-section speakers">
              <el-dropdown-item>
                <el-select
                  v-model="speaker"
                  collapse-tags
                  :popper-append-to-body="true"
                  popper-class="ai-evaluation-summary-page speakers-dropdown"
                  :class="{'both-speakers': speaker === 'both', 'all-speakers': speaker === 'all', 'agent-speakers': speaker === 'agent'}" 
                >
                  <el-option v-for="(speaker) in speakers" :key="speaker.key" :label="speaker.label" :value="speaker.key" :data-testid="`autoQM-dataInsights-AiConversationOverview-smartTag-` + speaker.label"> </el-option>
                </el-select>
              </el-dropdown-item>
            </div> 
          </div>
        </div>
        <div v-if="smartTagList.length>0"  class="sections-wrapper">
          <div class="div-tag" v-for="smartTag in smartTagList" :key="smartTag.label">
            <el-tooltip popper-class="section-title-popper" placement="bottom">
              <div slot="content">
                <div class="sections-smarttag-tooltip">
                  Categories: {{ smartTag.categories.join(', ') }}
                </div>
                <div class="sections-smarttag-tooltip">
                  Speaker: {{ smartTag.speakers.join(', ') }}
                </div>
              </div>
              <el-tag :disable-transitions="true">{{smartTag.label}}</el-tag>
            </el-tooltip>
          </div>
        </div>
        <div v-else class="sections-wrapper no-tags">
          --
        </div>
      </div>
    </div>
    <div v-else-if="hasTrendingTopicPermission||hasSmartTagsPermission" class="noAutoQM responsive-col">
      <div v-if="topicData && (topicData.topic || topicData.subTopic)">
        <span v-if="topicData && topicData.topic" class="flex justify-between">
          <div class="aiColor">Topic</div>
          <div class="topic-margin pr-10">{{ topicData.topic }}</div>
        </span>
      </div>
      <div v-else-if="topicData">
        <!-- BE returns {} -->
        <span class="flex justify-between">
          <div class="aiColor">Topic</div>
          <div class="topic-margin pr-10">--</div>
        </span>
      </div>
      <div v-if="hasSmartTagsPermission" class="col-inner-2 responsive-col">
        <div class="ai-tags-header">
          <div class="title">AI Tags</div>
          <div v-if="smartTags&&smartTags.length>0" class="dropdown-speakers">  
            <div class="filter-section speakers">
              <el-dropdown-item>
                <el-select
                  v-model="speaker"
                  collapse-tags
                  :popper-append-to-body="true"
                  popper-class="ai-evaluation-summary-page speakers-dropdown"
                  :class="{'both-speakers': speaker === 'both', 'all-speakers': speaker === 'all', 'agent-speakers': speaker === 'agent'}" 
                >
                  <el-option v-for="(speaker) in speakers" :key="speaker.key" :label="speaker.label" :value="speaker.key" :data-testid="`autoQM-dataInsights-AiConversationOverview-smartTag-` + speaker.label"> </el-option>
                </el-select>
              </el-dropdown-item>
            </div> 
          </div>
        </div>

        <div v-if="smartTagList.length>0"  class="sections-wrapper">
          <div class="div-tag" v-for="smartTag in smartTagList" :key="smartTag.label">
            <el-tooltip popper-class="section-title-popper" placement="bottom">
              <div slot="content">
                <div class="sections-smarttag-tooltip">
                  Categories: {{ smartTag.categories.join(', ') }}
                </div>
                <div class="sections-smarttag-tooltip">
                  Speaker: {{ smartTag.speakers.join(', ') }}
                </div>
              </div>
              <el-tag :disable-transitions="true">{{smartTag.label}}</el-tag>
            </el-tooltip>
          </div>
        </div>
        <div v-else class="sections-wrapper no-tags">
          --
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import WyConstants from "../../library/wy-constants";

export default Vue.extend({
  name: "wy-auto-ai-evaluation",
  data() {
    return {
      conversationId: null, // created hook will set this value with conversationId from url params
      topicData: null,
      evaluationData: null,
      sectionMap: {},
      formId: 0,
      smartTags: [],
      noAITags: false,
      speakers: [{ key: 'all', label: 'All'}, { key: 'agent', label: 'Agent'}, { key: 'customer', label: 'Customer'}],
      speaker: 'all', // Default speaker
    };
  },

  computed: {
    ...mapGetters(["authUser", "isRoleAllow", 'dataModel']),

    hasTrendingTopicPermission() {
      // Trending Topics 4600
      return this.isRoleAllow(4600)
    },

    hasAutoQAPermission() {
      // Auto QA 4700
      return this.isRoleAllow(4700)
    },

    hasSmartTagsPermission() {
      // Smart Tags 4900
      return this.isRoleAllow(4900)
    },

    hideAllContent() {
      return this.smartTags.length === 0 && (!this.evaluationData || !this.evaluationData.hasData) && (!this.topicData || Object.keys(this.topicData).length === 0) 
    },

    smartTagList() {
      if (!this.smartTags || this.smartTags.length === 0) {
        return [];
      }
      else {
        return this.smartTags.filter((tag) => {
          if (this.speaker === 'all') return true;
          return tag.speakers.includes(this.speaker);
        });
      }
    },    

    hasSummaryData() {
      return this.evaluationData && this.evaluationData.hasData
    }
  },

  methods: {
    ...mapActions(["fetchAutoQAEvalDataInsightScoresData", "fetchAutoQAEvalTopicGroupData", "fetchSmartTagsDataOnMediaPlayer", "postIFrameEvent"]),

    async fetchEvalData(conversationId) {
      if (!this.hasAutoQAPermission) return false;

      this.sectionMap = {};

      // scores -> /autoQA/autoQAEvalDataInsightScores
      const result = await this.fetchAutoQAEvalDataInsightScoresData({ conversationId: conversationId, pageName: "mediaPlayer", formId: this.formId });

      if (result && result.status != 200) {
        console.error("Failed to fetch data");
        return false;
      }
      this.evaluationData = result.data;
      if (this.evaluationData && this.evaluationData.evaluationComponents && this.evaluationData.evaluationComponents.length > 0) {
        this.evaluationData.evaluationComponents.forEach((component) => {
          this.sectionMap[component.name] = component;
        });
        this.formId = this.evaluationData.formId;
      }
     return this.evaluationData && this.evaluationData.hasData;
    },
    async fetchTopicData(conversationId) {
      if (!this.hasTrendingTopicPermission) return false;

      // topic -> /interactionsAnalytics/topicGroup{conversationId}
      const result = await this.fetchAutoQAEvalTopicGroupData({ conversationId });
      if (result && result.status != 200) {
        return false;
      }
      this.topicData = result.data;
      if((this.topicData && Object.keys(this.topicData).length > 0) && (this.topicData.topic || this.topicData.subTopic)) {
        return true;
      }
      return false;
    },

    async fetchSmartTagsData (conversationId) {
      if( !this.hasSmartTagsPermission) return false;
      const result = await this.fetchSmartTagsDataOnMediaPlayer({ conversationId });
      this.smartTags = result.data;
      if((this.smartTags && this.smartTags.length > 0)) {
        return true;
      }

      return false;
    },

    isOverflowing(name) {
      const maxWidth = 110; // px (max-width)
      const fontSize = 14;
      const letterSpacing = 0.5; // Approximation in px
      const approxWidth = name.length * (fontSize * 0.6 + letterSpacing); // 0.6 factor accounts for average character width
      
      return approxWidth > maxWidth;
    },

    async contentReloadListener(event) {
      if (event.data.channel === WyConstants.EVENT_MESSAGE_CHANNEL_MEDIAPLAYER) {
        if (event.data.action === 'AutoQA.AIAnalysis.reload') {
          if(this.formId > 0) {
            this.$router.app.setIFrameLoading(true);
            this.formId = event.data.formId;
            await this.fetchEvalData(this.contactId);
            this.$router.app.setIFrameLoading(false);
          }
        }
      }
    },
    hideDropdown() {
      let selectedItems = document.querySelectorAll('.ai-evaluation-summary-page.speakers-dropdown .el-select-dropdown__item.selected');
      if(selectedItems && selectedItems.length > 0) {
        selectedItems.forEach((selectedItem) => {
          selectedItem.click();
        });
      }
    }
  },

  async created() {
    this.contactId = this.$route.query.contactId;
    this.$router.app.setIFrameLoading(true);
    const [hasEvalData, hasTopicData, hasSmartTagsData] = await Promise.all([
      await this.fetchEvalData(this.contactId),
      await this.fetchTopicData(this.contactId),
      await this.fetchSmartTagsData(this.contactId)
    ]);
    this.$router.app.setIFrameLoading(false);
    
    this.postIFrameEvent({
      channel: WyConstants.EVENT_MESSAGE_CHANNEL_MEDIAPLAYER, 
      action: 'AutoQA.AIAnalysis.enable', hasData: (hasEvalData || hasTopicData || hasSmartTagsData),
    });
    
    window.addEventListener('message', this.contentReloadListener);
    let dom = document.querySelector('.wy-auto-qa-ai-evaluation-summary-main-page');
    if (dom) {
      dom.addEventListener("scroll", () => {
        this.hideDropdown();
      }, { passive: true });
      window.addEventListener("resize", () => {
        this.hideDropdown();
      }, { passive: true });
    }
  },

  destroyed() {
    window.removeEventListener('message', this.contentReloadListener);
  },
});
</script>

<style lang="scss">
$column-row-gap: 10px;
$column-gap: 30px;

$base-font-size: 14px;
$base-font-weight: 400;
$base-font-family: "Roboto", "Helvetica", "Arial", sans-serif !important;
$base-line-height: 18.75px;
$base-background-color: #ffffff;
$base-padding: 0;
$scale: 1;


.wy-auto-qa-ai-evaluation-summary-main-page {
  overflow-y: auto !important;
  overflow-x: hidden;
}
.wy-auto-qa-ai-evaluation-summary-page {
  background-color: #ffffff;
  overflow-x: hidden;
  overflow-y: hidden;
  .row-topic-section {
    display: none;
  }
  .row-ai-tags {
    display: none;
  }
}
.wy-auto-qa-ai-evaluation-summary-page .main-container {
  font-size: $base-font-size;
  font-weight: $base-font-weight;
  font-family: $base-font-family;
  line-height: $base-line-height;
  // background-color: $base-background-color;
  padding: $base-padding;

  background-color: #fafafa;
  display: grid;
  grid-template-columns: 240px 1fr;
  box-sizing: border-box;
  padding-top: 0px;
  height: 100%;

  .col-1 {
    scale: $scale;
    display: flex;
    flex-direction: column;
    gap: 0px;

    background-color: #D5F3FD; 
    padding: 12px 15px 5px 15px; 
    text-align: center;

    .large-title {
      font-weight: 900;
      font-weight: bold;
      font-size: 18px;
      color: #000000;
    }
    .title {
      font-weight: 900;
      font-size: 14px;
      color: #000000;
    }

    .score-wrapper {
      font-size: 34px;
      color: #000000;
      margin-top: 20px;

      .fw-bold {
        font-weight: 600;
      }
      .fw-100 {
        font-weight: 100;
      }

    }

    .target-wrapper {
      display: flex;
      font-weight: bold;
      margin-top: 12px;
      justify-content: space-around;
      span.target-value {
        background-image: var(--form-editor-target-icon);
        background-repeat: no-repeat;
        width: fit-content;
        display: flex;
        justify-content: flex-start;
        padding-left: 20px;
      }
    }

    .message-wrapper {
      font-style: italic;
      font-size: 12px;
      text-align: center;
      max-width: 210px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .col-2 {
    display: grid;
    grid-template-columns: 310px 1fr;
    gap: 10px;
    overflow-x: hidden;
    overflow-y: auto;
    border: 1px solid #D9D9D9;
    padding: 12px;
  }
  .col-2.no-ai-tags {
    grid-template-columns: 1fr;
    .sections-wrapper {
      column-count: 2;
      column-gap: $column-gap;
    }
  }

  .col-inner-1 {
    scale: $scale;
    gap: $column-gap;
    // padding: 0px 15px; 
    padding: 0px 10px 0px 0px;

    .title {
      font-weight: 900;
      font-size: 14px;
      color: #000000;
    }
    .topic-section {
      padding-bottom: 10px;
      .aiColor {
        color: #000000;
        font-size: 14px;
        font-weight: 900;
        padding-bottom: 3px;
      }
    }
    .evaluation-sections {
      // padding-top: 15px;
    }
    

    .sections-wrapper {
      // column-count: 2;
      // column-gap: $column-gap;
      margin-top: 5px;
      display: block;
      
      .section-row {
        display: flex;
        justify-content: space-between;
        margin-bottom: 5px;
        
        .section-title {
          margin-right: 30px;
          max-width: 310px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .section-score {
          font-weight: 700;
        }
      }
    }
  }

  .col-inner-2 {
    padding: 0px 0px 0px 15px; 
    border-left: 1px solid #D9D9D9;
    position: relative;
    top: -3px;
    .sections-wrapper {
      .div-tag {
        display: inline-block;
        width: fit-content;
        .el-tag {
          height: 26px;
          line-height: 24px;
          background-color: #FFF;
          border-color: #909096;
          margin-right: 10px;
          margin-bottom: 15px;
          font-size: 12px;
          color: #4A4A4F;
          cursor: default;
        }
      }
    }
  }
  .col-inner-2.responsive-col {
    .sections-wrapper {
      max-width: 290px;
    }
  }
  
  .col-2 {
    &::-webkit-scrollbar {
      // width: 8px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 200px;
      border-bottom: 4px solid transparent;
      border-top: 4px solid transparent;
      background-clip: content-box;
      background-color: #CAD2DA;
    }
    &::-webkit-scrollbar-track {
      margin-left: 4px;
    }
  }

  
}

.wy-auto-qa-ai-evaluation-summary-page .main-container.topic-only {
  display: flex;
  .col-2.no-ai-tags {
    width: 100%;
  }
}
.wy-auto-qa-ai-evaluation-summary-page .main-container.topic-ai-tags {
  grid-template-columns: auto;
  .col-2 {
    width: fit-content;
  }
}

.section-title-popper {
  padding: 6px !important;
  margin-bottom: 4px !important;
  margin-top: 6px !important;
}

.noAutoQM {
  scale: $scale;
  font-size: $base-font-size;
  font-weight: $base-font-weight;
  font-family: $base-font-family;
  line-height: $base-line-height;
  // background-color: $base-background-color;
  background-color: #fafafa;
  padding: $base-padding;
  padding-top: 10px;

  .col-inner-2 {
    padding: 0px 0px 0px 0px; 
    // border-left: 1px solid #D9D9D9;
    .sections-wrapper {
      .div-tag {
        display: inline-block;
        width: fit-content;
        .el-tag {
          height: 26px;
          line-height: 24px;
          background-color: #FFF;
          border-color: #909096;
          margin-right: 10px;
          margin-bottom: 15px;
          font-size: 12px;
          color: #4A4A4F;
          cursor: default;
        }
      }
    }
  }
}


.responsive-col {
  scale: $scale;
  display: flex;
  flex-direction: column;
  gap: $column-row-gap;

  .w-100px {
    width: 100px;
  }

  .flex {
    display: flex;
  }

  .title {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #000;
    font-weight: 900;
  }

  .justify-between {
    justify-content: space-between;
    display: block;
  }

  .topic.justify-between {
    justify-content: space-between;
    display: flex;
  }

  .topic-margin {
    font-weight: 500;
    // margin-left: 10px;
    white-space: nowrap;
    padding: 7px 0px 5px 0px;
    color: #000000;
    min-width: 73px;
  }


  .fw-700 {
    font-weight: 700;
  }
  .ai-tags-header {
    display: inline-flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .filter-section.speakers {
    .el-dropdown-menu__item {
      line-height: 25px;
      padding: 0px;
      position: relative;
      // top: -5px;
      
      .el-select.both-speakers {
        width: 150px;
      }
      .el-select.all-speakers {
        width: 70px;
      }
      .el-select.agent-speakers {
        width: 80px;
      }
      .el-select {
        margin-top: 0px;
        width: 100px;
        // height: 45px;
        
        .el-input.is-focus .el-input__inner {
          border-color: #2356E7;
        }
        .el-input .el-input__inner {
          border-color: #2356E7;
          color: #2356E7;
          font-weight: 500;
          padding-right: 20px;
        }
        .el-input__suffix {
          margin-right: 0px;
          right: 0px;

          .el-select__caret {
            color: #2356E7;
            font-weight: 500;
            margin-right: 5px;
            line-height: 30px;
          }
        }
        
      }
      .agent-groups.el-select {
        margin-top: 7px;
      }
      .devices.el-select {
        margin-top: 7px;
      }
      input.el-input__inner {
        border-width: 1px !important; 
        border-radius: 5px;
        padding-left: 10px;
        height: 27px;
        font-size: 13px;
      }
    }
  }
}

.el-select-dropdown.el-popper.ai-evaluation-summary-page.speakers-dropdown {
  .el-select-dropdown__item.selected {
    color: #4A4A4F;
  }
  .el-select-dropdown__item {
    font-size: 13px;  
    height: 25px;
    line-height: 25px;
    padding: 0px 10px;
  }
  .el-select-dropdown__list {
    padding: 6px 0 0px 0;
  }
  .popper__arrow {
    display: none;
  }
}

.aiColor {
  color: #000000;
  font-size: 14px;
  font-weight: 900;
}

.no-wrap {
  white-space: nowrap;
}
@media (max-width: 900px) {
// @media (max-width: 1600px) {
  .wy-auto-qa-ai-evaluation-summary-page {
    // background-color: #ffffff;
    background-color: #fafafa;
    overflow-x: hidden;
    // overflow-y: auto !important;
    .main-container {
      // display: block;
      // max-height: 145px;
      max-height: 155px;
      .col-2 {
        font-size: 12px;
        line-height: 13px;
        overflow-x: hidden !important;
        overflow-y: hidden !important;
        .sections-wrapper {
          display: flex;
          flex-direction: column;
          // justify-content: space-evenly;
          height: 100%;
          margin-top: 5px;
        }
      }
    }
    .main-container.topic-ai-tags {
      display: none;
    }
  }
  
  .responsive-col {
    display: none;
  }
  .noAutoQM.responsive-col {
    display: flex;
    .col-inner-2.responsive-col {
      display: flex;
      .dropdown-speakers {
        margin-right: 15px;
      }
    }
  }
  .topic-section {
    display: none;
  }
  .evaluation-sections {
    padding-top: 0px !important;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
  .row-topic-section {
    display: block !important;
    font-size: 14px;
    font-weight: 400;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif !important;
    line-height: 18.75px;
    padding-top: 15px;
    div.flex.justify-between {
      // width: max-content;
      .aiColor {
        font-weight: 900;
        padding-bottom: 12px;
        font-size: 14px;
        color: #000;
      }
    }
  }
  .row-ai-tags {
    display: block !important;
    font-size: 14px;
    font-weight: 400;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif !important;
    line-height: 18.75px;
    padding-top: 15px;

    .ai-tags-header {
      display: inline-flex;
      flex-direction: row;
      align-items: baseline;
      justify-content: space-between;
      width: 100%;

      .dropdown-speakers {
        margin-right: 15px;
      }
    }
    .filter-section.speakers {
      .el-dropdown-menu__item {
        line-height: 30px;
        padding: 0px;

        .el-select.both-speakers {
          width: 150px;
        }
        .el-select.all-speakers {
          width: 70px;
        }
        .el-select.agent-speakers {
          width: 80px;
        }
        .el-select {
          margin-top: 0px;
          width: 100px;

          .el-input.is-focus .el-input__inner {
            border-color: #2356E7;
          }
          .el-input .el-input__inner {
            border-color: #2356E7;
            color: #2356E7;
            font-weight: 500;
            padding-right: 20px;
          }
          .el-input__suffix {
            margin-right: 0px;
            right: 0px;

            .el-select__caret {
              color: #2356E7;
              font-weight: 500;
              margin-right: 5px;
              line-height: 30px;
            }
          }
        }
      }
      .agent-groups.el-select {
        margin-top: 7px;
      }
      .devices.el-select {
        margin-top: 7px;
      }
      input.el-input__inner {
        border-width: 1px !important; 
        border-radius: 5px;
        padding-left: 10px;
        height: 27px;
        font-size: 13px;
      }
    }

    .sections-wrapper {
      .div-tag {
        display: inline-block;
        width: fit-content;
        .el-tag {
          height: 26px;
          line-height: 24px;
          background-color: #FFF;
          border-color: #909096;
          margin-right: 10px;
          margin-bottom: 15px;
          font-size: 12px;
          color: #4A4A4F;
          cursor: default;
        }
      }
    }
    .title {
      font-size: 14px;
      color: #000;
      font-weight: 900;
      padding-bottom: 12px;
    }
  }
}
.wy-aiEvaluationSummary-page {
  .el-loading-mask {
    background-color: #fafafa !important;
  }
}

.el-tooltip__popper .sections-smarttag-tooltip {
  padding: 3px;
}
</style>
